module.exports = __webpack_public_path__ + "media/images/emblems/Hauenstein-Ifenthal-blason-a2fe3f7f7f29495301ebc09716cafce1.png";